import { Button } from "@mui/material";
import type { FC, ReactNode } from "react";

export type InspirationCtaVariant = "primary" | "secondary" | "tertiary";

export type InspirationCta = {
	label: string;
	icon?: ReactNode;
	onClick: () => void;
	variant?: InspirationCtaVariant;
};

type Props = {
	cta: InspirationCta;
};

export const InspirationCtaButton: FC<Props> = ({ cta }) => {
	return (
		<Button
			variant={cta.variant ?? "primary"}
			fullWidth
			startIcon={cta.icon}
			onClick={cta.onClick}
		>
			{cta.label}
		</Button>
	);
};
